import { REMOVE_PRO } from './../constants/index';
import { 
  LogInState, 
  logInActions
} from './../types/logInTypes';
import { 
  GET_USER,
  GET_LOCATION,
  ALLOW_LOCATION,
  SET_MYWALKS_URL,
  REMOVE_USER,
  SET_VIEW,
  SET_TEAM,
  SET_LANGUAGE,
  UPDATE_FILTER,
  ADD_PRO
} from '../constants/index';

const initialState: LogInState = {
  loggedIn: false,
  user: {
    WTTeams: false,
    WTTeamsPurchaseId: 0,
    teams: [],
    person: {
      firstName: '',
      lastName: '',
      email: '',
      picture: '',
      disabled: true,
      stars: null,
      emailVerified: false,
      id: null,
      biography: null
    },
    status: '',
    filter: null
  },
  position: {
    lng: null,
    lat: null
  },
  allowLocation: true,
  myWalksURL: 'created',
  viewMode: 'public',
  team: null,
  language: 'SWE'
}

const logInReducer = (state = initialState, action: logInActions) => {
  const payload = action.payload;
  
  switch(action.type){
    case GET_USER:
      return {
        ...state,
        user: payload,
        viewMode: 'public',
        loggedIn: true
      }

    case ADD_PRO:
      // console.log('redux:', payload)
      return {
        ...state,
        user: {
          ...state.user, 
          WTTeams: payload
        }
      }

    case REMOVE_PRO:
      return {
        ...state,
        user: {
          ...state.user, 
          WTTeams: false
        }
      }

    case REMOVE_USER: 
      return initialState

    case GET_LOCATION:
      return {
        ...state,
        position: {
          ...state.position,
          lng: payload.lng,
          lat: payload.lat
        }
      }
    
    case ALLOW_LOCATION:
      return {
        ...state,
        allowLocation: payload
      }

    case SET_MYWALKS_URL:
      return {
        ...state,
        myWalksURL: payload
      }

    case SET_VIEW: 
      return {
        ...state,
        viewMode: payload
      }

    case SET_TEAM:
      return {
        ...state,
        team: payload
      }

    case SET_LANGUAGE: 
       return {
         ...state,
         language: payload
       }
    
    case UPDATE_FILTER:
      return {
        ...state,
        user: {
          ...state.user,
          filter: payload
        }
      }
        
    default: 
      return state
  }
}

export default logInReducer;
